
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";

const AffiliateAgreement = () => {
  return (
    <Card className="mb-8">
      <CardHeader className="bg-orange-light">
        <CardTitle className="text-primary-dark">Partnership Agreement Terms</CardTitle>
      </CardHeader>
      <CardContent className="pt-6">
        <div className="space-y-4 text-gray-700">
          <div>
            <h4 className="font-semibold text-lg mb-2">Commission Structure:</h4>
            <ul className="list-disc list-inside space-y-1">
              <li>DNA Testing Services: 3-5% commission on confirmed appointments</li>
              <li>DOT Physical Exams: 2-3% commission on confirmed appointments</li>
              <li>Drug Testing: 2-4% commission on confirmed appointments</li>
              <li>Other Services: 2-3% commission on confirmed appointments</li>
            </ul>
          </div>
          
          <div>
            <h4 className="font-semibold text-lg mb-2">Payment Terms:</h4>
            <ul className="list-disc list-inside space-y-1">
              <li>Commissions are calculated when appointments are confirmed</li>
              <li>Monthly payments via direct deposit or check</li>
              <li>Minimum payout threshold: $50</li>
              <li>Payment processing: 30-45 days after service completion</li>
            </ul>
          </div>

          <div>
            <h4 className="font-semibold text-lg mb-2">Referral Tracking:</h4>
            <ul className="list-disc list-inside space-y-1">
              <li>Each approved partner receives a unique referral code</li>
              <li>Customers enter your code when booking appointments</li>
              <li>Real-time tracking available through your partner portal</li>
              <li>Detailed monthly reporting provided</li>
            </ul>
          </div>

          <div>
            <h4 className="font-semibold text-lg mb-2">Requirements:</h4>
            <ul className="list-disc list-inside space-y-1">
              <li>Professional representation of NearLab Services</li>
              <li>Accurate information about our services and pricing</li>
              <li>Compliance with all applicable laws and regulations</li>
              <li>Regular communication and reporting as requested</li>
            </ul>
          </div>
        </div>
      </CardContent>
    </Card>
  );
};

export default AffiliateAgreement;
